class BESSAppCalcReportSearch extends BESSAppComponent {

    constructor() {
        super('.app-calc-report-search');
    }

    setupComponent(node) {
        node.keyup(function () {
            let term = $(this).val().trim().toLowerCase();
            $('.calc-message').each(function () {
                let m = $(this);
                let contents = m.html().toLowerCase();
                if (term.length === 0) {
                    m.show();
                } else {
                    if (contents.indexOf(term) >= 0) {
                        m.show()
                    } else {
                        m.hide();
                    }
                }
            });
        });
    }
}